<template>
  <ValidationObserver
    class="vuetify-form"
    ref="obs"
    v-slot="{ invalid, passes }"
  >
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <v-layout row align-end>
        <v-flex xs12 class="pl-3" ref="commentForm">
          <ValidationProvider :rules="commentRules" v-slot="{ errors, valid }">
            <v-textarea
              :error-messages="errors"
              :success="valid"
              placeholder="Write a comment"
              v-model="commentDesc"
              auto-grow
              multi-line
              ref="input"
              rows="2"
              @keydown.enter="submit()"
              outlined
              dense
              hide-details
              class="comment-field"
            />
            <div class="text-right py-2" v-if="$vuetify.breakpoint.mdAndUp">
              <v-btn
                @click="cancel()"
                small
                text
                color="red"
                :disabled="disableCancelBtn"
                class="mx-1 btn-style"
              >
                Cancel
              </v-btn>
              <v-btn
                :disabled="invalid"
                @click="passes(submit)"
                color="#096DD8"
                class="btn-style"
                :dark="!invalid"
                :loading="saving"
                small
              >
                {{
                  formAction == "editComment"
                    ? "Save"
                    : parentId
                    ? "Reply"
                    : "Comment"
                }}
              </v-btn>
            </div>
          </ValidationProvider>
        </v-flex>
      </v-layout>
    </div>
    <div v-else>
      <v-row
        justify="center"
        align="center"
        :class="{ 'ma-0': $vuetify.breakpoint.xsOnly }"
      >
        <v-col
          :cols="$vuetify.breakpoint.smOnly ? 10 : 9"
          class="px-1 "
          ref="commentForm"
        >
          <ValidationProvider :rules="commentRules" v-slot="{ errors, valid }">
            <v-textarea
              :error-messages="errors"
              :success="valid"
              placeholder="Write a comment"
              v-model="commentDesc"
              auto-grow
              multi-line
              ref="input"
              rows="1"
              @keydown.enter="submit()"
              outlined
              dense
              hide-details
              class="comment-field"
            />
          </ValidationProvider>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.smOnly ? 1 : 3"
          class="px-1"
          ref="commentForm"
        >
          <v-btn
            :disabled="invalid"
            @click="passes(submit)"
            :dark="!invalid"
            :loading="saving"
            small
            color="#096DD8"
            class="pa-5"
          >
            <img src="@/assets/Vector.png" alt="Dislike" />
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </ValidationObserver>
</template>

<script>
import { NewsFeedService } from "@/services";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  name: "comment-form",
  props: {
    parent: {
      type: Object
    },
    comment: {
      type: Object
    },
    showSaveButton: {
      type: Boolean,
      default: true
    },
    value: [Object],
    formAction: {
      type: String,
      default: "addComment"
    },
    inputField: String
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      saving: false,
      commentDesc: "",
      commentRules: {
        required: true
        //commentRegex: /^(?:[A-Za-z]+)(?:[A-Za-z0-9 _]*).+$/,
      },
      disableCancelBtn: this.inputField == "reply" ? false : true
    };
  },
  computed: {
    /**
     * The parent comment's ID
     */
    parentId() {
      return this.parent ? this.parent._id : null;
    },
    newsfeedId() {
      return this.$store.state.newsFeedsComment.newsFeedId;
    }
  },
  methods: {
    cancel() {
      if (this.inputField == "reply") {
        this.$refs.commentForm.hidden = true;
        this.$parent.showCommentForm = false;
      }
      this.$refs.input.reset();
      this.$refs.obs.reset();
    },
    async submit() {
      this.saving = true;
      if (this.formAction == "editComment") {
        const object = {
          description: this.commentDesc
        };
        const response = await NewsFeedService.editComment(
          object,
          this.parent._id
        );
        if (response) {
          this.$store.dispatch("user/setSnack", response.data.msg);
          this.$store.dispatch("user/setType", "info");
          this.$parent.showCommentForm = false;
          let commentData = response.data.data;
          this.$emit("newsfeedEdited", commentData);
          //this.$store.commit('newsFeedsComment/setComment',commentData)
          this.$emit("saved");
          this.commentDesc = "";
          this.$refs.obs.reset();
        }
      } else {
        const object = {
          description: this.commentDesc,
          newsFeedId: this.newsfeedId
        };
        if (this.parentId) {
          object.parentId = this.parent.parentId
            ? this.parent.parentId
            : this.parentId;
        }
        const response = await NewsFeedService.addComment(object);
        if (response) {
          this.$store.dispatch("user/setSnack", response.data.msg);
          this.$store.dispatch("user/setType", "info");
          this.commentDesc = "";
          this.$refs.obs.reset();
          if (this.inputField == "reply") {
            this.$parent.$parent.$parent.getComments();
          } else {
            this.$parent.$parent.getComments();
          }
          this.$parent.showCommentForm = false;
          if (object.parentId) this.$emit("updateResponseList", object);
          this.$emit("saved");
        }
      }
      this.saving = false;
    }
  },
  mounted() {
    // Emit initial values of local properties
    this.$emit("update:saving", this.saving);
  },
  created() {
    if (this.parent) {
      if (this.formAction == "editComment") {
        this.commentDesc = this.parent.description;
      }
    }
  },
  /**
   * Emit changes to local properties
   */
  watch: {
    saving(newVal) {
      this.$emit("update:saving", newVal);
    },
    formAction(newVal) {
      if (this.parent) {
        if (newVal === "editComment") {
          this.commentDesc = this.parent.description;
        }
      }
    },
    commentDesc(val) {
      this.disableCancelBtn = typeof val == "undefined" ? true : false;
    }
  }
};
</script>
<style scoped>
.v-application .success--text,
.v-application .primary--text {
  color: #9cc2f6 !important;
  caret-color: #9cc2f6 !important;
  background-color: #f6fafe !important;
}
.btn-style {
  text-transform: capitalize;
}
</style>
